import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import global_css from './global-css';
import {IFilter, IFilterable} from './interfaces/filterable';

@customElement('ri-filter-view')
export class FilterView extends LitElement {
  name = '过滤视图';
  subtitle = '所有的东西！';
  @property({type: Array}) filterables: IFilterable[] = [];
  get _currentFilterables() {
    return this.filterables
      .filter((filterable: IFilterable) => {
        let include = this.intersection;
        for (const filter of this.filters) {
          // Skip any special filters
          if (
            [...this.possibleFilters].find((f) => f.name === filter)?.condition
          )
            continue;
          if (this.intersection) {
            if (!filterable.tags.has(filter)) {
              include = false;
              break;
            }
          } else {
            if (filterable.tags.has(filter)) {
              include = true;
              break;
            }
          }
        }
        for (const filter of this.possibleFilters) {
          if (filter.condition) {
            if (filter.only) {
              if (this.filters.has(filter.name)) {
                include = filter.condition(filterable);
              }
              continue;
            }
            if (
              !this.filters.has(filter.name) &&
              filter.condition(filterable)
            ) {
              include = false;
              break;
            }
          }
        }
        return include;
      })
      .map((filterable) => {
        if (this.replace) {
          let el: LitElement & {filterable?: IFilterable} =
            this._replacements[filterable.name];
          if (!el) {
            el = document.createElement(this.entryClass);
            el.filterable = filterable;
            this._replacements[filterable.name] = el;
          } else {
            el.requestUpdate();
          }
          return el as IFilterable;
        }
        return filterable;
      })
      .sort(
        this.reverse ? (a, b) => this.compare(b, a) : this.compare
      ) as LitElement[];
  }

  possibleFilters: Set<IFilter> = new Set();
  get _currentFilters() {
    return [...this.possibleFilters]
      .filter(
        (filter) =>
          filter.condition ||
          this.filterables.some(
            (f) => (!('unlocked' in f) || f.unlocked) && f.tags.has(filter.name)
          )
      )
      .map(
        (filter) => html`<input
            type="checkbox"
            class="filter"
            ?checked=${this.filters.has(filter.name)}
            id=${filter.name}
            value=${filter.name}
            @change=${this._onFilterToggle}
          /><label class="filter chip ${filter.name}" for=${filter.name}
            >${filter.displayName}</label
          >`
      );
  }
  filters: Set<string> = new Set();
  /** If true, requires an intersection of all filters
   * instead of just a single filter to be true.
   */
  @property({type: Boolean, reflect: true}) intersection = false;
  @property({type: Boolean, reflect: true}) reverse = false;
  @property({type: Boolean}) replace = false;
  @property() entryClass = 'div';
  @property() _replacements: Record<string, LitElement> = {};

  static override styles = [
    global_css,
    css`
      :host {
        display: flex;
        flex-direction: column;
      }
      .header,
      .filters,
      .bottom-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
      }
      .bottom-container {
        overflow-y: auto;
      }
      .bottom-container * {
        margin: 4px;
      }
      .header {
        justify-content: space-between;
      }
      .top-container,
      .bottom-container {
        width: auto;
        height: auto;
      }
    `,
  ];

  override render() {
    return html`
      <div class="top-container">
        <div class="header">
          <h4>${this.name}<span> - ${this.subtitle}</span></h4>
          <div class='filter-view-options'>
            <input
              type="checkbox"
              id="intersection"
              ?checked=${this.intersection}
              @change=${(event) => {
                this.intersection = event.target.checked;
                this.requestUpdate();
              }}
            /><label class="chip" for="intersection">反相滤波器</label>
            <button
            @click=${this._onFullscreenToggle}
            >⤢</button>
          </div>
        </div>
        <hr />
        <div class="filters">
          <!-- <strong>Filters: </strong> -->
          ${this._currentFilters}
        </div>
        <hr />
        </div>
        <div class="bottom-container">
            ${this._currentFilterables}
        </div>
      </div>
    `;
  }
  compare(a: IFilterable, b: IFilterable) {
    return 0;
  }
  protected _onFilterToggle(e) {
    if (e.target.checked) {
      if (e.target.value) this.filters.add(e.target.value);
    } else {
      this.filters.delete(e.target.value);
    }
    this.requestUpdate();
  }

  protected _onFullscreenToggle() {
    this.classList.toggle('fullscreen');
  }
}
